<template>
  <RadioGroupRoot v-model="internalState" aria-label="Visibility" asChild>
    <ScrollableList>
      <template #items>
        <RadioGroupItem
          as="div"
          v-for="visibility in visibilities"
          :key="visibility.id"
          class="flex items-center justify-between border rounded-md gap-3 py-3 px-4 hover:cursor-pointer transition-all select-none data-[state=unchecked]:bg-white data-[state=unchecked]:hover:bg-gray-50 data-[state=checked]:bg-[#E1EBF8] data-[state=checked]:border-[#79AAE1] data-[state=checked]:text-[#3b60ba]"
          :value="visibility.id"
        >
          {{ t(visibility.label) }}
        </RadioGroupItem>
      </template>
    </ScrollableList>
  </RadioGroupRoot>
</template>

<script setup>
import { ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";
import { RadioGroupRoot, RadioGroupItem } from "radix-vue";
import { ScrollableList } from "@/Components/List";
import { visibilities } from "@/Components/Visibility";

const { t } = useI18n();

const emit = defineEmits(["change"]);

const props = defineProps({
  activeVisibility: { type: String, default: "" },
});

const internalState = ref(props.activeVisibility);

watchEffect(() => {
  emit("change", internalState.value);
});
</script>
